// @flow

import * as React from 'react';

import { Outlet } from 'react-router-dom';

import { useTranslator } from '@gandi/translate';

import { Intro } from 'src/Layout';
import { Layout } from 'src/components/Layout';

function Presenter(): React.Node {
  const { __ } = useTranslator();

  return (
    <Layout>
      <Intro title={__('Organization information')} />
      <Outlet />
    </Layout>
  );
}

export default Presenter;
